import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingTextToImageAiConfig } from '@/data/landingConfig/landingTextToImageAiConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_TextToImageAi } from './schemaObject';

interface Props {}
const TextToImageAi: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_TextToImageAi} />
			<LandingTemplate
				data={landingTextToImageAiConfig}
				funnelLinkService={GenerateLandingLinkService.funnelImageGeneratorV2()}
			/>
		</>
	);
};

export default TextToImageAi;
